import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { JwtService } from '@gray/domain/http/jwt.service';
import { CoachStateService } from '../services/coach-state.service';

@Injectable()
export class CoachErrorInterceptor implements HttpInterceptor {
  constructor(
    private jwtService: JwtService,
    private coachState: CoachStateService,
    private router: Router,
    private translate: TranslateService,
    private toastService: ToastrService,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          // The login screen renders its own messages, so it is left out of the global handling.
          const isLoginRequest = req.url.includes('/coach/authentication/login');

          switch (error.status) {
            case 401:
              if (!isLoginRequest) {
                this.jwtService.destroyToken();
                this.coachState.clear();
                this.router.navigateByUrl('/auth/login');
              }
              break;
            case 403:
              if (!isLoginRequest) {
                this.toastService.warning(`${this.translate.instant('errors.coach_passive')}`);
                this.jwtService.destroyToken();
                this.coachState.clear();
                this.router.navigateByUrl('/auth/login');
              }
              break;
          }
        }

        return throwError(error);
      })
    );
  }
}
